import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.41 28.994c-.38 0-.75-.1-1.09-.32l-6.3-4h-.01l-6.23 4c-.9.47-1.81.41-2.47-.1-.64-.49-.92-1.31-.74-2.14l1.87-7.22-5.69-4.79c-.66-.55-.91-1.43-.64-2.25.26-.81.98-1.37 1.82-1.42l7.38-.48 2.8-6.97c.13-.37.39-.7.73-.94.69-.49 1.65-.48 2.34 0 .34.24.6.58.75.97l2.74 6.9 7.42.52c.84.05 1.56.61 1.82 1.42.27.82.01 1.71-.64 2.26l-5.65 4.71 1.79 7.26c.21.84-.1 1.7-.79 2.21-.36.26-.78.39-1.2.39zm-7.37-24.96-2.84 6.93c-.13.35-.37.67-.69.91-.32.23-.7.37-1.09.4l-7.37.47c-.07.11-.04.14-.02.15l5.65 4.71c.3.25.53.58.65.95.12.38.14.77.04 1.16l-1.87 7.19s0 .08.02.09c.02.02.11.02.25-.05l6.13-3.95c.66-.42 1.53-.42 2.18 0l6.3 4h.08l-.01-.1-1.83-7.18a2.08 2.08 0 0 1 .69-2.11l5.65-4.71s.04-.04.02-.1l-7.42-.52c-.39-.02-.77-.16-1.09-.4-.32-.23-.56-.56-.7-.93l-2.74-6.9z"
    />
  </svg>
);
const SvgIconStar = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconStar);
export default Memo;
